import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface IStoreInfo {
  branchId: string | undefined;
  setBranchId: (branchId: string | undefined) => void;
}

const useStoreInfo = create<IStoreInfo>()(
  devtools<IStoreInfo>((set) => ({
    branchId: undefined,
    setBranchId: (branchId) => set(() => ({ branchId })),
  })),
);

export default useStoreInfo;
